module.exports = __webpack_public_path__ + "img/size3_en.9cbb8a50.png";